export default __webpack_public_path__ + "static/media/hzhomeimage3.9aee779c.jpg";